import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./CongratsSuccessmodal.css";
function CongratsSuccessmodal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} className="congratsModal" centered>
      <Modal.Body className="text-center">
        <>
          <div className="content_holder">

            <h4>CONGRATULATIONS!</h4>

            <p>You have completed the process successfully!</p>

            <div className="alert alert-light" role="alert">
              Your request to become a Seller with us, is under review. If you
              have any queries, please reach out us at{" "}
              <a href="mailto:admin@loconextech.com">
                admin@loconextech.com
              </a>{" "}
              / <a href="tel:+916262171723">+91 6262171723</a>.
            </div>

            <p className="bottom_text">
              Process would take 7 - 8 days to review.
              <br />
              We are eager to see you with us!
            </p>
          </div>

          <div className="footer_div">
            <p
              className="dismissbtn"
              onClick={handleClose}
            >
              Dismiss
            </p>
          </div>
        </>

       
      </Modal.Body>
    </Modal>
  );
}

export default CongratsSuccessmodal;
